import { render } from "./BdcomGponTable.vue?vue&type=template&id=298caab6&scoped=true"
import script from "./BdcomGponTable.vue?vue&type=script&lang=js"
export * from "./BdcomGponTable.vue?vue&type=script&lang=js"

import "./BdcomGponTable.vue?vue&type=style&index=0&id=298caab6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298caab6"]])

export default __exports__